import type { BasketByType } from "lib/apollo/types"
import type { ItemType } from "@shared/graphql.types"
import { isItemAvailable } from "utils/isItemAvailable"
import { pluralize } from "utils/pluralize"
import { sortItem } from "utils/sortItem"

export const getBasketByType = (basket: ItemType[]): BasketByType => {
  const initial: BasketByType = {
    memberships: [],
    giftMemberships: [],
    products: [],
    inStock: [],
    outOfStock: [],
    insiders: [],
  }

  return basket.reduce((sortedItems, item) => {
    if (!item) return sortedItems

    // should out of stock products be added to products?
    if (!isItemAvailable(item)) {
      sortItem(sortedItems, "outOfStock", item)
      return sortedItems
    }

    // put in stock and sort by type
    sortItem(sortedItems, "inStock", item)
    sortItem(sortedItems, pluralize(item.type), item)

    return sortedItems
  }, initial)
}
